const SubTitle = ({ children, className = '' }) => {
  return (
    <h4
      className={`mt-6 font-alliance-medium text-[16px] lg:text-[22px] ${
        !className.includes('mb') ? 'mb-12' : ''
      } ${className}`}
    >
      {children}
    </h4>
  )
}

export default SubTitle
